/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum BulkUpdateVisitsErrorReason {
  VISIT_IS_SCHEDULED="VISIT_IS_SCHEDULED",
VISIT_IS_SCHEDULING="VISIT_IS_SCHEDULING",
VISIT_IS_LOCKED="VISIT_IS_LOCKED",
VISIT_IS_COMPLETED="VISIT_IS_COMPLETED",
VISIT_IS_DELETED="VISIT_IS_DELETED",
UNKNOWN_REASON="UNKNOWN_REASON"
}

/**
* BulkUpdateVisitsErrorReason
*/
export const BulkUpdateVisitsErrorReasonEnumType = types.enumeration("BulkUpdateVisitsErrorReason", [
        "VISIT_IS_SCHEDULED",
  "VISIT_IS_SCHEDULING",
  "VISIT_IS_LOCKED",
  "VISIT_IS_COMPLETED",
  "VISIT_IS_DELETED",
  "UNKNOWN_REASON",
      ])
